import React, { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { RouteComponentProps } from "react-router-dom";
import { ExperimentState, VacationRentalsModuleProps } from "redmond";
import { useUserContext, isCorpTenant } from "@capone/common";

import config from "../../../utils/config";
import { colors as caponeColors } from "../../../utils/capone/colors";
import { colors as corpColors } from "../../../utils/capone-corporate/colors";
import ItineraryReviewBackground from "../../../assets/b2b/itinerary-review-background.jpeg";
import App from "../../../../../../cap1-modules/vacation-rentals-module/src/App";

interface ILegacyVacationRentalsBookProps extends RouteComponentProps {
  language: string;
  experiments?: ExperimentState;
  showCoreHomepage?: boolean;
}

// Renders VR checkout when the replatformed (b2bportal) shop is enabled; the
// microfrontend (VacationRentalsModule) still handles it otherwise. The
// microfrontend is a separate React root, and tearing it down mid-commit on
// book -> shop navigation stranded its open MUI portals (modal backdrops) over
// the replatformed shop. Rendering App inside the host tree unmounts it as a
// normal subtree. Same pattern as LegacyPremierCollectionVRBook
// (../LegacyPremierCollectionBook) for the luxury VR checkout.
export const LegacyVacationRentalsBook = (
  props: ILegacyVacationRentalsBookProps
) => {
  const { language, experiments, showCoreHomepage, ...routerProps } = props;
  const { history } = routerProps;
  const theme = useTheme();

  const { sessionInfo, policies, logo, isRewardsDisabled } = useUserContext(
    config.TENANT
  );

  const moduleProps: VacationRentalsModuleProps & {
    showCoreHomepage?: boolean;
    skipPortalProvider?: boolean;
  } = useMemo(
    () => ({
      theme,
      language,
      colors: isCorpTenant(config.TENANT) ? corpColors : caponeColors,
      baseHistory: history,
      isAgentPortal: config.ptIsAgentPortal,
      experiments,
      clientAssets: {
        logo: <img src={logo?.src} alt={logo?.alt} />,
        itineraryReviewBackground: ItineraryReviewBackground,
        sessionInfo,
        policies,
        isRewardsDisabled,
      },
      showCoreHomepage,
      // Already nested under BaseProviders' CaponePortal/CorporatePortal.
      skipPortalProvider: true,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isRewardsDisabled]
  );

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <App {...moduleProps} />;
};
